import last from 'lodash/last';
import { CSSProperties } from 'react';

import { useGenericCombinedFinancing } from '~src/hooks/useGenericCombinedFinancing';
import { DeepPartial, OfferProducts } from '~src/model';
import { calculatePaybackTime } from '~src/util';

import { SavingsEstimateBase } from './SavingsEstimateBase';

type SavingsEstimateProps = {
  style?: CSSProperties;
  products?: DeepPartial<OfferProducts>;
  savings?: { saved: { price?: number; emission?: number; priceByYear?: number[] } };
  financing?: ReturnType<typeof useGenericCombinedFinancing>;
  showLoan?: boolean;
  setShowLoan: (showLoan: boolean) => void;
};

export const SavingsEstimate = ({
  savings,
  products,
  style,
  financing,
  showLoan,
  setShowLoan,
}: SavingsEstimateProps) => {
  const { saved } = savings ?? {};
  const { priceByYear } = saved ?? {};

  const price = products?.price ?? 0;

  const { paybackFormatted } = calculatePaybackTime(price, years => priceByYear?.[years] ?? last(priceByYear) ?? 0);

  const paybackTime = showLoan
    ? `${Math.floor((financing?.instalments.length ?? 0) / (financing?.instalmentsByYear.length ?? 0))} år`
    : paybackFormatted;

  return (
    <SavingsEstimateBase
      style={style}
      totalPrice={price}
      paybackTime={paybackTime}
      savedAnnually={saved?.price}
      showLoan={showLoan}
      setShowLoan={setShowLoan}
      co2SavedAnnually={saved?.emission}
      financingMonthlyPayment={financing?.paymentPerMonth}
      financingTotalPaid={financing?.totalPaid}
    />
  );
};
